/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
export enum PermalinkType {
  Viewing = 'viewing',
  Publishing = 'publishing',
}